class CartFlyout extends HTMLElement {
  constructor() {
    super();

    // Add animate class immediately for slide transitions
    this.classList.add('animate');

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartFlyout-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    // Only set up if flyout is enabled
    if (!window.NEWTON_CART_FLYOUT_ENABLED) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // Animation timeout to ensure CSS transition triggers
    setTimeout(() => {
      this.classList.add('active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.cart-flyout__inner-empty')
          : document.getElementById('CartFlyout');
        const focusElement = this.querySelector('.cart-flyout__inner') || this.querySelector('.cart-flyout__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');

    // Wait for slide-out animation to complete
    const inner = this.querySelector('.cart-flyout__inner');
    const handleTransitionEnd = () => {
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    };

    inner.addEventListener('transitionend', handleTransitionEnd, { once: true });
  }

  renderContents(parsedState) {
    this.querySelector('.cart-flyout__inner').classList.contains('is-empty') &&
      this.querySelector('.cart-flyout__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (sectionElement) {
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartFlyout-Overlay');
      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      }
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-flyout',
        selector: '#CartFlyout',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-flyout', CartFlyout);

class CartFlyoutItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartFlyout-CartItems',
        section: 'cart-flyout',
        selector: '#CartFlyout-CartItems',
      },
      {
        id: 'CartFlyout-Header',
        section: 'cart-flyout',
        selector: '.cart-flyout__header',
      },
      {
        id: 'CartFlyout-Summary',
        section: 'cart-flyout',
        selector: '.cart-flyout__summary-wrapper',
      },
      {
        id: 'CartFlyout-Footer',
        section: 'cart-flyout',
        selector: '.cart-flyout__footer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.errors) {
          const quantityElement = document.getElementById(`Flyout-quantity-${line}`);
          if (quantityElement) {
            quantityElement.value = quantityElement.getAttribute('value');
          }
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);

        // Update each section
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id) || document.querySelector(section.selector);
          if (elementToReplace && parsedState.sections[section.section]) {
            const html = new DOMParser().parseFromString(parsedState.sections[section.section], 'text/html');
            const newContent = html.querySelector(section.selector);
            if (newContent) {
              elementToReplace.innerHTML = newContent.innerHTML;
            }
          }
        });

        // Re-bind overlay click listener after update
        const overlay = document.querySelector('#CartFlyout-Overlay');
        if (overlay) {
          overlay.addEventListener('click', () => {
            document.querySelector('cart-flyout').close();
          });
        }

        this.disableLoading(line);
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
        this.disableLoading(line);
      });
  }

  enableLoading(line) {
    const item = document.getElementById(`CartFlyout-Item-${line}`);
    if (item) {
      item.classList.add('is-loading');
    }
  }

  disableLoading(line) {
    const item = document.getElementById(`CartFlyout-Item-${line}`);
    if (item) {
      item.classList.remove('is-loading');
    }
  }
}

customElements.define('cart-flyout-items', CartFlyoutItems);

